// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"ec5c115f","465":"3ef2c2d8","528":"7c55bfc3","678":"cf133ea2","991":"17131ccf"}[chunkId] + ".chunk.css";
};